import React from 'react';
const IsNonActivePortfolio = function() {
    return <div/>;
  };
export default IsNonActivePortfolio;
